import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/women";

export default class Women extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Women's")} | ${this.ucfirst("window-title")}`
    );
  }
}
